import { Component, input, output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatListModule } from '@angular/material/list';
import { TranslatePipe } from '@ngx-translate/core';

import { UiSidebarNavItem, UiSidebarUser } from './ui-sidebar.types';
import { UiLabelTranslatePipe } from '../ui-label-translate.pipe';

@Component({
  selector: 'ui-sidebar',
  standalone: true,
  imports: [MatListModule, RouterLink, RouterLinkActive, TranslatePipe, UiLabelTranslatePipe],
  templateUrl: './ui-sidebar.component.html',
  styleUrls: ['./ui-sidebar.component.scss']
})
export class UiSidebarComponent {
  readonly items = input<UiSidebarNavItem[]>([]);
  readonly collapsed = input(false);
  readonly user = input<UiSidebarUser>({
    name: 'Demo User',
    role: 'Admin',
    initials: 'DU'
  });
  readonly collapsedChange = output<boolean>();
  readonly expandedGroups = new Set<string>();

  toggleCollapsed(): void {
    this.collapsedChange.emit(!this.collapsed());
  }

  onLogoClick(): void {
    if (this.collapsed()) {
      this.collapsedChange.emit(false);
    }
  }

  toggleGroup(path: string): void {
    if (this.expandedGroups.has(path)) {
      this.expandedGroups.delete(path);
      return;
    }

    this.expandedGroups.add(path);
  }

  isGroupExpanded(path: string): boolean {
    return this.expandedGroups.has(path);
  }
}
